import type { EventDetailsDto } from "@/api/types";
import { Breadcrumbs } from "@/components/Breadcrumbs/Breadcrumbs";
import { PageGrid } from "@/components/PageGrid/PageGrid";
import { DocumentPaper } from "@/components/Paper/DocumentPaper";
import { useSlug } from "@/hooks/useSlug";
import { routes } from "@/routes";
import { useTranslation } from "@/translations";

import { EventDetails } from "./components/EventDetails";
import { EventDetailsParticipantsSection } from "./components/EventDetailsParticipantsSection";

export interface LayoutProps {
  eventDetails: EventDetailsDto;
}
export function Layout(props: LayoutProps): React.ReactNode {
  const { t } = useTranslation();
  const slug = useSlug();

  return (
    <DocumentPaper
      title={t("page.event.details.title")}
      subTitle={
        <Breadcrumbs
          pages={[
            {
              name: t("page.calendar.title"),
              to: routes.calendar.list({
                slug,
              }),
            },
            {
              name: t("page.event.details.title"),
            },
          ]}
        />
      }
    >
      <PageGrid.Grid>
        <PageGrid.Item size="66%">
          <EventDetails event={props.eventDetails} />
        </PageGrid.Item>
        <PageGrid.Item size="33%">
          <EventDetailsParticipantsSection event={props.eventDetails} />
        </PageGrid.Item>
      </PageGrid.Grid>
    </DocumentPaper>
  );
}
